<template>
  <span>
    <object-link
      v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CAFETERIAS)"
      :object="cafeteria"
    />
    <span v-else>{{ $objectDenomination(cafeteria) }}</span>
  </span>
</template>

<script>
import formMixin from "@/mixins/form-mixin";

export default {
  name: "cafeteria",

  components: {},

  mixins: [formMixin],

  props: {
    cafeteria: {
      type: Object,
      default: () => ({}),
      description: "Cafeteria",
    },
  },

  data() {
    return {};
  },

  setup() {},

  created() {},

  methods: {},

  watch: {
    cafeteria(cafeteria) {},
  },
};
</script>
